export const APPLICATION_GLOBALS: any = {
    MONTHS: {
        LABELS: {
            1: "Stycznia", 2: "Lutego", 3: "Marca",
            4: "Kwietnia", 5: "Maja", 6: "Czerwca",
            7: "Lipca", 8: "Sierpnia", 9: "Września",
            10: "Października", 11: "Listopada", 12: "Grudnia"
        }
    }
};


export default APPLICATION_GLOBALS;
